export enum LabelSequentialType {
    Alphabetical = 'alphabetical', 
    Numerical = 'numerical'
}

